import "./index.scss";
import React from 'react';
import { useEffect } from "react";
import { message, Spin } from "antd";
import { feishuAuth } from "../../model/api";
import { parse } from 'query-string';

const Auth = (props) => {

    useEffect(() => {
        // console.log("auth page props=", props)
        // 获取浏览器地址参数
        const params = new URLSearchParams(window.location.search)
        const codeValue = params.get('code')
        // console.log("codevalue=", codeValue, params)
        if (codeValue != null) {
            // console.log("feishu login logic is effective")
            toAuth(codeValue)
        } else {
            console.log("code is null, default login is effective")
            props.history.push('/login')
        }
    }, [])

    const toAuth = async (codeValue) => {
        try {
            // const appAddress = window.location.origin + '/admin'
            const res = await feishuAuth({ code: codeValue, redirect_uri: window.location.origin + '/auth' })
            // console.log("auth data=", res)
            if (res) {
                const { data } = res;
                localStorage.setItem('accessToken', data.access_token);
                localStorage.setItem('user', JSON.stringify(data))
                localStorage.setItem('loginTime', new Date().getTime())
                // window.location.href = appAddress + '/dashboard'
                // navigate("/")
                const { redirect } = parse(window.location.search);
                console.log("auth redirect params=", parse(window.location.search))
                props.history.push(redirect || '/')
            } else {
                message.error('登录报错，请联系系统管理员处理！')
            }
        } catch (err) {
            console.log("err=", err)
            message.error('请求后端服务报错')
        }
    }

    return (
        <div className='container'>
            <Spin />
        </div>
    );
};

export default Auth;
